import React from "react";
import { useParams } from "react-router-dom";
import GenericDashboard from "../GenericDashboard/GenericDashboard";
import FormConfig from '../../Config/FormConfig.js'
import APIService from "../../Service/APIService";
import CustomHeader from "../CustomHeader/CustomHeader";
import { Button, Input, message, Row, Col, Upload, DatePicker } from "antd";
import * as yup from 'yup';
import { Formik } from 'formik';
import Swal from "sweetalert2";
import dayjs from "dayjs";
import { UploadOutlined } from '@ant-design/icons';
import Select from 'react-select';

const AssignAccountToDistUser = (props) => {
    const { assignAccountData } = props;
    const [userOptions, setUserOptions] = React.useState([]);
    const [selectedUser, setSelectedUser] = React.useState(null);
    const getDistUsers = async () => {
        const apiServe = new APIService();
        const response = await apiServe.getDataFromBackend(`getdistnonmanagerbydistid?DistributorID=${assignAccountData?.DistributorID}`);
        console.log("Distributor Users: ", response);
        return response?.data?.data;
    }

    React.useEffect(() => {
        console.log("Assign Account to Distributor User component mounted");
        getDistUsers().then((data) => {
            console.log('Distributor Users:', data);
            const tempData = [];
            data.forEach((element) => {
                tempData.push({
                    ...element,
                    value: element.ID,
                    label: element.FirstName + ' ' + element.LastName
                });
            });
            setUserOptions(tempData);
        });
    }, []);

    const submitHandler = async () => {
        if (!selectedUser) {
            Swal.fire({
                title: 'Error!',
                text: 'Please select a user',
                icon: 'error',
                confirmButtonText: 'Ok'
            });
        }
        Swal.fire({
            title: 'Are you sure?',
            text: 'Do you want to assign this account to the user?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, assign it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                const apiServe = new APIService();
                const postObj = {
                    AccountID: assignAccountData?.ID,
                    AccountName: assignAccountData?.AccountName,
                    DistributorID: assignAccountData?.DistributorID,
                    DistributorName: assignAccountData?.DistributorName,
                    DistributorUserID: selectedUser.value,
                    UserID: selectedUser.UserID,
                    Username: selectedUser.FirstName + ' ' + selectedUser.LastName
                }
                const response = await apiServe.addDataToBackend(postObj, "assigndistusertoaccount");
                console.log("Update Account Response: ", response);
                if (response?.status === 200 || response?.status === 201) {
                    Swal.fire(
                        'Assigned!',
                        'The account has been assigned.',
                        'success'
                    ).then(() => {
                        window.location.reload();
                    });
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Error while assigning user to account!'
                    });
                }
            }
        })
    }

    return (
        <>
            <Row gutter={16}>
                <Col span={24} style={{ width: '100%' }}>
                    <label className="form-label">Assign To</label>
                    <Select
                        placeholder="Choose User"
                        options={userOptions}
                        onChange={(value) => setSelectedUser(value)}
                        styles={{width: '100%'}}
                    />
                </Col>
            </Row>
            <p>
                This action will assign this user to <strong>{assignAccountData?.AccountName}</strong>. However, the following account data will not be available:
                <ul>
                    <li style={{ listStyleType: 'disc' }}>Orders and Invoices while account was assigned to a different user</li>
                    <li style={{ listStyleType: 'disc' }}>IVRs created while account was assigned to a different user</li>
                </ul>
            </p>
            <p>

                <div style={{ display: 'flex', justifyContent: 'end' }}>
                    <Button type="primary" style={{ background: '#27a907' }} onClick={submitHandler}>Save</Button>
                </div>
            </p>
        </>
    )
}

export default AssignAccountToDistUser;